'use client'
import { Section } from '@dynamo-caffeina-dev/airc-ui-kit'

import { NormalizedSection } from '@/types'
import { useMemo } from 'react'

export interface EmbedProps extends NormalizedSection {
  modelledContent: {
    embed: {
      src: string
    }
  }
}

const Embed = ({ modelledContent }: EmbedProps) => {
  const { embed } = modelledContent

  function getContentType() {
    const hasVideoContent = /https:\/\/(www)?.(youtube|vimeo).com/.test(
      embed?.src
    )
    // …other content types

    if (hasVideoContent) return 'video'

    return 'generic'
  }

  const contentType = useMemo(getContentType, [embed.src])

  return (
    <Section
      className='section-embed'
      data-content-type={contentType}
    >
      <div className='section-embed__container'>
        {embed.src && (
          <div
            className='section-embed__container__inner'
            dangerouslySetInnerHTML={{ __html: embed.src }}
          />
        )}
      </div>
    </Section>
  )
}

export default Embed
